import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 35,
  height: 29,
}

const gourmetBalcony = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 35.124 28.813'
  >
    <g fill={color}>
      <path
        d='M36.8,2.744a7.569,7.569,0,0,0-4.23,1.32,6.863,6.863,0,0,0-12.533,0,7.569,7.569,0,0,0-4.23-1.32A7.177,7.177,0,0,0,9.458,6.625a.686.686,0,0,0,1.223.622,5.793,5.793,0,0,1,5.125-3.131A5.952,5.952,0,0,1,19.868,5.7a.686.686,0,0,0,1.143-.3,5.49,5.49,0,0,1,10.581,0,.686.686,0,0,0,1.143.3A5.952,5.952,0,0,1,36.8,4.116,5.669,5.669,0,0,1,42.492,9.6a5.692,5.692,0,0,1-6.305,5.455.686.686,0,0,0-.761.682v6.212H31.79v-3.43a.686.686,0,0,0-1.372,0v3.43h-3.43v-3.43a.686.686,0,0,0-1.372,0v3.43h-3.43v-3.43a.686.686,0,0,0-1.372,0v3.43H17.178V15.74a.686.686,0,0,0-.761-.682,5.785,5.785,0,0,1-5.736-3.1.686.686,0,1,0-1.223.622,7.177,7.177,0,0,0,6.347,3.881V28.126a.686.686,0,0,0,.686.686h19.62a.686.686,0,0,0,.686-.686V16.464A7.039,7.039,0,0,0,43.864,9.6,7.039,7.039,0,0,0,36.8,2.744Zm-19.62,24.7V23.324H35.426V27.44Zm0,0'
        transform='translate(-8.74)'
      />
      <path
        d='M.686,131.372A.686.686,0,1,0,0,130.686.686.686,0,0,0,.686,131.372Zm0,0'
        transform='translate(0 -121.082)'
      />
    </g>
  </svg>
)

export default gourmetBalcony
